import { CoreDataSecurityApplicationsName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { getCoreDataSecurityApplicationsSlice } from './get';
import { PatchDataSecurityApplicationByIdRequest } from '@api/data-security';

export const updateCoreDataSecurityApplicationSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreDataSecurityApplicationsName,
	state: getCoreDataSecurityApplicationsSlice.asyncState,
	target: (request: PatchDataSecurityApplicationByIdRequest) => (app) => app.applicationId === request.applicationId,
	update: (request: PatchDataSecurityApplicationByIdRequest) => (app) => ({
		...app,
		...request
	})
});
